import React from 'react';
import { getFlagUrl } from '../utils/countries';

interface CountryFlagProps {
  countryCode?: string;
  className?: string;
  alt?: string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({ countryCode, className = 'w-10 h-10', alt }) => {
  if (!countryCode) return null;

  return (
    <img 
      src={getFlagUrl(countryCode)} 
      alt={alt || countryCode}
      className={`${className} rounded-lg shadow-lg object-cover`}
      loading="lazy"
    />
  );
};

export default CountryFlag;
